import axios from 'axios';
import {
  UPDATE_USER_API,
  API_URL_JOBS,
  API_KEY_ACCOUNTS,
  API_KEY_JOBS,
} from '../../constants';

export const updateBuilderPersonalInfo = async (
  updatedValues,
  builderId,
  previousValues,
) => {
  const token = localStorage.getItem('accessToken');
  const email = localStorage.getItem('username');
  const { businessNumber, priorityListing, deactivate, reason } = updatedValues;

  const changedValues = Object.keys(updatedValues).filter(
    k => updatedValues[k] !== previousValues[k],
  );
  // console.log(
  //   { updatedValues, previousValues, changedValues },
  //   'updatedValues',
  // );
  // return;
  const currentdeactivatedValue = updatedValues.deactivate;
  delete updatedValues.businessNumber;
  delete updatedValues.priorityListing;
  delete updatedValues.deactivate;
  delete updatedValues.reason;

  const response = await axios({
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': `${API_KEY_ACCOUNTS}`,
      Authorization: `Bearer ${token}`,
    },
    url: `${UPDATE_USER_API}/${builderId}`,
    data: updatedValues,
    validateStatus(status) {
      return status === 200;
    },
  });
  // console.log({ response }, 'response');
  if (response.status === 200 && businessNumber) {
    if (changedValues && changedValues.length >= 1) {
      /* eslint-disable no-await-in-loop */
      for (let i = 0; i < changedValues.length; i += 1) {
        if (changedValues[i] === 'custom:buildingLicNo') {
          await createActivity(
            token,
            builderId,
            localStorage.getItem('username'),
            'Builder Licence Number Updated',
          );
        } else if (changedValues[i] === 'reason') {
          console.log('chnaged reason');
          await createActivity(
            token,
            builderId,
            localStorage.getItem('username'),
            'Builder Deactivation Reason Updated',
          );
        } else if (changedValues[i] === 'custom:buildingLicExp') {
          await createActivity(
            token,
            builderId,
            localStorage.getItem('username'),
            'Builder Licence Expiry Updated',
          );
        } else if (changedValues[i] === 'custom:personalPhone') {
          await createActivity(
            token,
            builderId,
            localStorage.getItem('username'),
            'Primary Contact Number Updated',
          );
        } else if (changedValues[i] === 'priorityListing') {
          await createActivity(
            token,
            builderId,
            localStorage.getItem('username'),
            `Priority Listing ${
              previousValues.priorityListing === 0 ? 'Enabled' : 'Disabled'
            }`,
          );
        } else if (changedValues[i] === 'deactivate') {
          if (currentdeactivatedValue === true) {
            console.log('came to true');
            await createActivity(
              token,
              builderId,
              localStorage.getItem('username'),
              'Builder Deactivated',
            );
          }
          if (currentdeactivatedValue === false) {
            console.log('came to false');
            await createActivity(
              token,
              builderId,
              localStorage.getItem('username'),
              'Builder Activated',
            );
          }
        }
      }
    }
    await axios({
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': `${API_KEY_JOBS}`,
        Authorization: `Bearer ${token}`,
      },
      url: `${API_URL_JOBS}/admin/businesses/${businessNumber}/priority`,
      data: {
        priority: priorityListing ? 1 : 0,
        deactivate,
        reason,
        adminEmail: email,
      },
      validateStatus(status) {
        return status === 200;
      },
    });
  }
  updatedValues.priorityListing = priorityListing;
  return response.data;
};

const createActivity = async (
  accessToken,
  builderId,
  username,
  activityName,
) => {
  // console.log('came here', { activityName });
  await axios({
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_JOBS,
    },
    data: {
      builderId,
      username,
      activityName,
    },
    url: `${API_URL_JOBS}/activityLog/admin`,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
};
